
import { Component, Prop, Vue } from "vue-property-decorator";
import ILoginQuery from "@/models/login-query";
import formRules from "@/models/form-rules";
import UserAuthService from "@/services/user-auth-service";

@Component({
  components: {}
})
export default class LoginForm extends Vue {
  formValid = false;
  username: string | null = null;
  password: string | null = null;
  showPassword = false;
  loading = false;
  showLogin = true;

  rules = formRules;

  @Prop({ default: false, type: Boolean })
  isDialog!: boolean;

  async created() {
    if (this.isDialog) return;
    document.addEventListener("userLogin", this.loginActions);
    const refreshToken = this.$route.query["refreshToken"];
    if (refreshToken) {
      this.showLogin = false;
      await this.$router.replace("/login");
      await this.loginFromRefreshToken(String(refreshToken));
      this.showLogin = true;
      return;
    }
  }

  async mounted() {
    if (this.isDialog) return;
    if (this.$dataService.getters.Auth.isUserLogged()) {
      if (this.$route.query["redirect"]) {
        /* tslint:disable:no-string-literal */
        return this.$router.replace(String(this.$route.query["redirect"]));
      } else {
        return this.$router.replace("/");
      }
    }
  }

  async login() {
    if (!this.username) return;
    if (!this.password) return;
    const userInfo: ILoginQuery = {
      userName: this.username,
      password: this.password
    };

    try {
      this.loading = true;
      const { data } = await this.$dataService.actions.Auth.loginUser(userInfo);
      if (!data.encryptKey) throw new Error("Encrypt Key not present!");
      UserAuthService.setEncryptKey(data.encryptKey);
      delete data.encryptKey;
      this.$dataService.actions.Auth.putUserInfo(data);
      this.$dataService.actions.TimeOut.start();
      this.$emit("login", true);
      this.loading = false;
      if (this.isDialog) return;
      /* tslint:disable:no-string-literal */
      if (this.$route.query["redirect"]) {
        /* tslint:disable:no-string-literal */
        await this.$router.replace(String(this.$route.query["redirect"]));
      } else {
        await this.$router.replace("/");
      }
    } catch (error: any) {
      if (error && error.name && error.name === "NavigationDuplicated") return;
      this.$dataService.actions.showErrorExceptionMessage(error);
      return;
    } finally {
      this.loading = false;
    }
  }

  async loginFromRefreshToken(refreshToken: string) {
    try {
      this.loading = true;
      const { data } = await this.$dataService.actions.Auth.refreshToken(refreshToken);
      if (!data.encryptKey) throw new Error("Encrypt Key not present!");
      UserAuthService.setEncryptKey(data.encryptKey);
      this.$dataService.actions.Auth.putUserInfo(data);
      delete data.encryptKey;
      return this.loginActions();
    } catch (error: any) {
      this.$dataService.actions.showErrorExceptionMessage(error);
      return this.$router.replace("/login");
    } finally {
      this.loading = false;
      this.showLogin = true;
    }
  }

  private async loginActions() {
    this.$dataService.actions.TimeOut.start();
    this.$emit("login", true);
    return await this.$router.replace("/");
  }
}
